import Loading from 'vue-loading-overlay';
import Select2Multiple from "v-select2-multiple-component";
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import 'vue-loading-overlay/dist/vue-loading.css';
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import store from '../../store';
import axios from "axios";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: "PaymentReport",
    components: {
        Loading,
        Select2Multiple,
        MainLayout,
        Bar
    },

    data() {
        const chartDefaults = {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
              duration: 800,
              easing: 'easeOutQuart'
          },
          scales: {
              x: {
                  title: {
                      display: true,
                      text: 'Months',
                      font: {
                          weight: '600',
                          size: 14
                      },
                      color: '#4b5563'
                  },
                  ticks: {
                      maxRotation: 45,
                      minRotation: 0,
                      color: '#374151',
                      font: {
                          size: 12,
                          weight: '500'
                      },
                      autoSkip: false
                  },
                  grid: {
                      color: '#f3f4f6',
                      drawBorder: false
                  }
              },
              y: {
                  title: {
                      display: true,
                      text: 'Amount',
                      font: {
                          weight: '600',
                          size: 14
                      },
                      color: '#4b5563'
                  },
                  ticks: {
                      callback: (value) => value.toLocaleString(),
                      color: '#374151',
                      font: {
                          size: 12,
                          weight: '500'
                      }
                  },
                  grid: {
                      color: '#f3f4f6',
                      drawBorder: false
                  }
              },
          },
          plugins: {
            legend: {
              display: true,
              position: 'top'
            },
            tooltip: {
              backgroundColor: 'rgba(17, 24, 39, 0.95)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: 'transparent',
              borderWidth: 0,
              padding: 12,
              cornerRadius: 8,
              titleFont: {
                weight: '600',
                size: 14
              },
              bodyFont: {
                size: 13
              },
              callbacks: {
                label: function (context) {
                  return `${context.dataset.label}: ${Math.round(context.parsed.y).toLocaleString()}`;
                }
              }
            }
          },
        };

        return {
            isLoading: false,
            incomeExpense: null,
            selectedAcdYear: 0,
            yearArr: [],
            chartData: {
                labels: [],
                datasets: []
            },
            chartOptions: chartDefaults,
            totalIncome: null,
            totalExpense: null,
        };
    },

    methods: {
        changeEvent(val, fieldName) {
            if (fieldName === 'year') {
                this.selectedAcdYear = val;
            }
            this.getIncomeExpenseReport();
        },

        getIncomeExpenseReport() {
            this.isLoading = true;
            var request = {
                params: {
                    campus_id: store.state.user.campus_id,
                    acd_year_id: this.selectedAcdYear,
                }
            }
            axios.get("/report/income-expense", request)
                .then(response => {
                    this.chartData = {
                        ...this.chartData,
                        labels: response.data.month_year,
                        datasets: [
                            {
                                label: 'Income',
                                data: response.data.income,
                                backgroundColor: 'rgba(16, 185, 129, 0.9)',
                                borderColor: 'rgba(16, 185, 129, 1)',
                                borderWidth: 2,
                                borderRadius: 6,
                                maxBarThickness: 60
                            },
                            {
                                label: 'Expense',
                                data: response.data.expense,
                                backgroundColor: 'rgba(239, 68, 68, 0.9)',
                                borderColor: 'rgba(239, 68, 68, 1)',
                                borderWidth: 2,
                                borderRadius: 6,
                                maxBarThickness: 60
                            }
                        ]
                    };
                    this.getTransactionInfo();
                    this.isLoading = false;
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.log("Payment Transaction API Error", error);
                });
        },

        getCurrentPeriodList() {
            var request = {
                params: {
                    campus_id: store.state.user.campus_id,
                }
            }
            this.isLoading = true;
            axios.get('/period/getCurrentPeriodList', request)
                .then(res => {
                    if(res.data.length == 1){
                        this.selectedAcdYear = res.data[0].id;
                        this.getIncomeExpenseReport()
                    }else{
                        this.chartData = null;
                    }
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getAcademicYear() {
            axios.get('getAcademicYear', {
                params: {
                    campus_id: store.state.user.campus_id
                }
            })
            .then(res => {
                let $defaultSelectOption = [{
                    'id': 0, // 0 is default (if 0, reports will result according to today)
                    'text': 'Select Academic Year'
                }];
                this.yearArr = $defaultSelectOption.concat(res.data.academicYearArr);

            }).catch((error) => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
            });
        },

        getTransactionInfo() {
          axios.get("/transaction/info", { 
                params: { 
                    campus_id: this.$store.state.user.campus_id,
                    acd_year_id: this.selectedAcdYear,
                }
            })
            .then((response) => {
              this.totalIncome = response.data.income;
              this.totalExpense = response.data.outcome;
            })
            .catch((error) => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
              console.log("Income Expense API Error", error);
            });
        },
    },

    mounted() {
        require("@/assets/plugins/css/select2.css");
        require("@/assets/css/report.css");
        this.isLoading = true;
        this.getCurrentPeriodList();
        this.getAcademicYear();
    },
};
